import React from 'react'
import { Breadcrumb } from 'react-bootstrap'

interface KnowledgeBreadcrumbProps {
    locale: string
    nameCategory?: string
    nameKnowledge: string
}

const KnowledgeBreadcrumb: React.FC<KnowledgeBreadcrumbProps> = ({
    locale,
    nameCategory = "",
    nameKnowledge = ""
}) => {
    return (
        <Breadcrumb>
            <Breadcrumb.Item href={`/${locale}/knowledges/`}>Knowledges</Breadcrumb.Item>
            {!!nameCategory && <Breadcrumb.Item active>
                {nameCategory}
            </Breadcrumb.Item>}
            <Breadcrumb.Item active>{nameKnowledge}</Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default KnowledgeBreadcrumb